module.exports = __webpack_public_path__ + "static/media/freesticker.cb687014.svg";